import ClientsScreen from "@/UI/screens/ClientsScreen";

export default function ClientsRoute() {
    return <ClientsScreen />;
}
